import React, { FC } from 'react';
import { Grid } from '@mui/material';
import TextInputField from 'Components/Forms/TextInputField';
import CountrySelect from 'Components/Forms/CountrySelect';
import { FieldWrapper } from 'DesignSystem';
import { FastField as Field } from 'formik';

interface IAddressFieldsProps {
  fullWidth?: boolean;
  accessor?: string;
}

const AddressFields: FC<IAddressFieldsProps> = ({ fullWidth, accessor = '' }) => {
  return (
    <Grid item xs={fullWidth ? 12 : 6}>
      <Grid container spacing={3}>
        <Grid item xl={9} lg={9} md={9} xs={12}>
          <TextInputField
            label="Street Name"
            name={`${accessor}street`}
            data-testid="street-name-field"
          />
        </Grid>
        <Grid item xl={3} lg={3} md={3} xs={12}>
          <TextInputField
            label="Number"
            name={`${accessor}streetNumber`}
            data-testid="street-number-field"
          />
        </Grid>
        <Grid item xl={6} lg={6} md={6} xs={12}>
          <TextInputField
            label="Postal Code"
            name={`${accessor}zipCode`}
            data-testid="zip-code-field"
          />
        </Grid>
        <Grid item xl={6} lg={6} md={6} xs={12}>
          <TextInputField label="City" name={`${accessor}city`} data-testid="city-field" />
        </Grid>
        <Grid item xs={12}>
          <FieldWrapper label="Country">
            <Field component={CountrySelect} name={`${accessor}country`} />
          </FieldWrapper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddressFields;
